
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BarChart3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface EmptyTestHistoryStateProps {
  activeTab: string;
}

export default function EmptyTestHistoryState({ activeTab }: EmptyTestHistoryStateProps) {
  const navigate = useNavigate();

  return (
    <Card className="text-center py-12">
      <CardContent>
        <BarChart3 className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Nenhum resultado encontrado
        </h3>
        <p className="text-gray-500 mb-4">
          {activeTab === 'all' 
            ? 'Você ainda não realizou nenhum teste de personalidade.' 
            : `Você ainda não realizou o teste de ${activeTab === 'big-five' ? 'Big Five' : 'Esquemas de Young'}.`}
        </p>
        <Button onClick={() => navigate('/testes-personalidade')}>
          Fazer um teste agora
        </Button>
      </CardContent>
    </Card>
  );
}
